import {Injectable}     from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router}    from '@angular/router';
import {AngularFireAuth} from "angularfire2/auth";

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private af: AngularFireAuth, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.af.authState.map(auth => {
      if (!auth) {
        this.router.navigateByUrl('auth/login');
        return true;
      }
      return !!auth;
    });
  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/roche/roche/src/app/auth/auth-guard.service.ts